import React from 'react';
import {Card} from '../Card/Card';
import "./cardsStyles.css";
 // props = {
//     Cards : string[]
// round 
// }
// cardData 
// handleOnKeyPress
// cardShow 
export const Cards = (props) =>{
    const cards = props.cardData[props.round].map((val, key) => {
        return (
            <div className="card" key={key} onKeyDown={props.handleOnKeyPress}>
                <Card 
                answer={val.ans} 
                score = {val.score} 
                isShown={props.cardShow[key]}/>
            </div>
        )
    })
    return (
        <div className="cards-container">
            {cards}
        </div>
    )
}